import LegalPage from './LegalPage';

const SECTIONS = [
  {
    title: '1. Eliminación Automática',
    content: 'La plataforma de New horizont start conserva únicamente los últimos 3 meses de conversaciones y mensajes. Los registros con más de 3 meses de antigüedad son eliminados automáticamente de la base de datos de forma permanente, sin necesidad de que el usuario realice ninguna acción.',
  },
  {
    title: '2. Cómo Solicitar la Eliminación de sus Datos',
    content: 'Si desea solicitar la eliminación de su cuenta y de los datos personales asociados, puede hacerlo enviando una solicitud a:\n\n• Correo: newhorizontstart@gmail.com\n• Celular / WhatsApp: +57 300 621 4893\n\nEn la solicitud indique el nombre de usuario o el correo asociado a su cuenta para poder identificarla.',
  },
  {
    title: '3. Plazo de Respuesta',
    content: 'Una vez recibida y verificada su solicitud, eliminaremos sus datos personales de nuestros sistemas en un plazo máximo de 30 días hábiles, salvo aquellos que la ley colombiana exija conservar por motivos de auditoría o cumplimiento normativo.',
  },
  {
    title: '4. Datos en WhatsApp y Meta',
    content: 'Los datos procesados a través de la WhatsApp Business Platform de Meta se rigen adicionalmente por las políticas de Meta. La eliminación realizada por New horizont start abarca los datos almacenados en nuestra plataforma; para datos en posesión de Meta puede ejercer sus derechos directamente ante dicha empresa.',
  },
  {
    title: '5. Contacto',
    content: 'Para cualquier duda sobre la eliminación de datos puede comunicarse a newhorizontstart@gmail.com o al celular +57 300 621 4893.',
  },
];

function EliminacionDatos() {
  return (
    <LegalPage
      title="Eliminación de Datos"
      subtitle="New horizont start · Colombia"
      updatedAt="11 de junio de 2026"
      sections={SECTIONS}
    />
  );
}

export default EliminacionDatos;
